

export const types = {
    authLogin: '[auth] Login',
    authCheckingFinish: '[auth] Finish checking login state',
    authStartRegister: '[auth] Start Register',
    authLogout: '[auth] Logout',

    findLoading: '[ui] findLoading',
    openMenu: '[ui] Open sidebar',
    verMenu: '[ui] Open verMenu',
    verNotification: '[ui] Open verNotification',
    openModalInsert: '[ui] Open Modal Insert',
    openModalEdit: '[ui] Open Modal Edit',
    openModalSee: '[ui] Open Modal See',
    openNotifications: '[ui] openNotifications',
    handleLoading: '[ui] handleLoading',

    findUsers: '[users] findUsers',
    insertUser: '[users] insertUser',
    updateUser: '[users] updateUser',
    deleteUser: '[users] deleteUser',

    findGender: '[gender] findGender',

    findUsersContract: '[users] findUsersContract',

    findcontract: '[contract] findcontract',

    findPlans2: '[plan] findPlans2',

    findpaymentMethod: '[paymentMethod] findpaymentMethod',

    findcontractStatus: '[contractStatus] findcontractStatus',

    findCivilStatus: '[civilStatus] findCivilStatus',

    findRoles: '[roles] findRoles',

    findRoles2: '[roles] findRoles2',

    findPermits: '[permit] findPermits',

    findPermits2: '[permit] findPermits2',

    findModules: '[Modules] findModules',

    findModules2: '[Modules] findModules2',

    findFleets: '[fleet] findFleets',

    findCompanies: '[companies] findCompanies',

    findPlans: '[plan] findPlans',

    findDepartament: '[departament] findDepartament',

    findVehicles: '[vehicle] findVehicles',

    findAvailability: '[availability] findAvailability',

    findWorkShops: '[Workshop] findWorkShops',

    repairOrders: '[repairOrder] repairOrders',

    repairOrdersTypes: '[repairOrderType] repairOrdersTypes',

    findNotifications: '[notification] findNotifications',

    findPatmentsRepairsOrders: '[findPatmentsRepairsOrders] findPatmentsRepairsOrders',

    loadingPay: '[loadingPay] loadingPay',

    saveDataVehiclePaymet: '[saveDataVehiclePaymet] saveDataVehiclePaymet',

    saveDataReport: '[saveDataReport] saveDataReport',

    saveIdFleet: '[saveIdFleet] saveIdFleet',

    findUserFleet: '[findUserFleet] findUserFleet',

    saveIdDepart: '[saveIdDepart] saveIdDepart',

    findUserDepart: '[findUserDepart] findUserDepart',

    findOcupation2: '[ui] findOcupation2',
    findOcupation: '[ui] findOcupation',
    saveOcupation: '[ui] saveOcupation',
    updateOcupation: '[ui] updateOcupation',
    daleteOcupation: '[ui] daleteOcupation',


    findGender: '[ui] findGender',

    findPropiedades: '[ui] findPropiedades',
    findPropiedadesId: '[ui] findPropiedadesId',
    findPropiedadesUltimos: '[ui] findPropiedadesUltimos',

    findTipoOfertas: '[ui] findTipoOfertas',
    findTipoInmuebles: '[ui] findTipoInmuebles',
    findTipoPagos: '[ui] findTipoPagos',

    findEtapaDesarrollo: '[ui] findEtapaDesarrollo',
    findEstadoLote: '[ui] findEstadoLote',
    findDesarrollos: '[ui] findDesarrollos',

    findLote: '[ui] findLote',
    findLoteById: '[ui] findLoteById',
    findDesarrollo: '[ui] findDesarrollo',
    findBlog: '[ui] findBlog',


    findAllColaboradores: '[ui] findAllColaboradores',
    findDesarrollosCount: '[ui] findDesarrollosCount',
    findPropiedadesCount: '[ui] findPropiedadesCount',

    findBlogId: '[ui] findBlogId',
    findBlogsRecientes: '[ui] findBlogsRecientes',
}
